import { UserSessionsForDebugApi } from "../../generated"
import { useQuery } from 'react-query'
import { apiConfig } from "../apiConfig"
import { onError } from "../../admin/stores/user/UserStore"
import { DebugLoginOption } from "./DebugLoginOption"

const api = new UserSessionsForDebugApi(apiConfig)

async function load() {
  return await api.listAdmin()
}

export function useAdminList() {
  const { data } = useQuery('useAdminList', load, { onError })
  const options: DebugLoginOption[] | undefined = data?.map(admin => { return { value: admin.account, label: `${admin.name} (${admin.account})` } })
  return options ? options : []
}
